import { Builder } from '@builder.io/react';
import { ScrollingBannerBuilder } from '../components/dividers/ScrollingBanner';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';

Builder.registerComponent(ScrollingBannerBuilder, {
    name: BUILDER_DIVIDER_NAMES.ScrollingBanner,
    friendlyName: 'Ticker scroll divider',
    inputs: [
        {
            name: 'statements',
            type: 'list',
            required: true,
            onChange: (options) => {
                const items = options.get('statements');
                if (items.length > 10) {
                    options.set('statements', items.slice(0, 10));
                    alert('Maximum 10 statements allowed');
                }

                if (items.length < 5) {
                    alert('Minimum 5 statements required. Please add more statements.');
                }
            },
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    required: true,
                    helperText:
                        'Enter a statement to display in the banner. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
                },
            ],
            defaultValue: [
                { text: '{{treatmentsPerMonth}} Monthly Treatments' },
                { text: '{{clinicCount}} Clinics Nationwide' },
                { text: 'Permanent Results' },
                { text: '100% Medical Oversight' },
                { text: 'Safe for All Skin Tones' },
                { text: '4.94 average rating' },
            ],
            helperText:
                'Add statements to display in the scrolling banner (each will be shown in uppercase with a star icon)',
        },
        {
            name: 'backgroundColor',
            friendlyName: 'Background Color',
            type: 'string',
            enum: ['Black', 'Navy', 'White', 'Turquoise', 'Blue', 'Blue10', 'TrueWhite', 'WhiteOff'],
            defaultValue: 'Black',
            helperText: 'Select the background color of the banner section',
        },
        {
            name: 'textColor',
            friendlyName: 'Text Color',
            type: 'string',
            enum: ['TrueWhite', 'Navy', 'Turquoise', 'Black', 'Blue', 'White'],
            defaultValue: 'TrueWhite',
            helperText: 'Select the color for the statement text',
        },
        {
            name: 'iconColor',
            friendlyName: 'Icon Color',
            type: 'string',
            enum: ['White', 'Navy', 'Blue', 'Turquoise20'],
            defaultValue: 'Turquoise20',
            helperText: 'Select the color of the star icon that appears before each statement',
        },
        {
            name: 'scrollSpeed',
            friendlyName: 'Scroll Speed',
            type: 'number',
            defaultValue: 30,
            min: 1,
            max: 60,
            helperText: 'Animation duration in seconds (higher = slower). Range: 1-60 seconds',
        },
        {
            name: 'itemGap',
            friendlyName: 'Item Gap',
            type: 'number',
            defaultValue: 60,
            min: 1,
            max: 100,
            helperText: 'Gap between items in pixels. Range: 1-100 pixels',
        },
        {
            name: 'pauseOnHover',
            friendlyName: 'Pause on Hover',
            type: 'boolean',
            defaultValue: true,
            helperText: 'When enabled, scrolling animation pauses when user hovers over the banner',
        },
    ],
});
